import Tooltip from 'rc-tooltip';
import cx from 'classnames';
import {Button} from '~library/atoms/Button';
import {Divider} from '~library/atoms/Divider';
import {Typography} from '~library/atoms/Typography';
import {ArrowIcon} from '~library/svg/ArrowIcon';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {DuplicateIcon} from '~library/svg/DuplicateIcon';
import {DuplicateDropdown} from '~/SignUpSheets/Create/routes/Customize/components/Builder/Elements/SlotToolBar/DuplicateDropdown';
import {
  selectIsAutoSorting,
  selectShouldShowAdvancedOptions,
} from '~/SignUpSheets/reducers/blueprint/selectors';

import {pebble} from '~libSass/base/_exports.sass';
import 'rc-tooltip/assets/bootstrap.css';
import './SlotToolBar.sass';

export const SignupOptionTools = ({
  className,
  index,
  isMobile = true,
  revealOnHover = evite.detects.isDesktop && !isMobile, // If MW, always show since we don't have hover on MW
  isOnlySignupOption = false,
  onDeleteItem,
  onMoveItemUp,
  onMoveItemDown,
  canMoveUp = false,
  canMoveDown = false,
  onDuplicateItem,
  onCopySlotsToEmptyDate,
  blueprintType,
  isDesktop = false,
}) => {
  const isDateTimeBlueprint = selectShouldShowAdvancedOptions({
    blueprint: {blueprint_type: blueprintType},
  });
  const isAutoSorting = selectIsAutoSorting({blueprint: {blueprintType}});
  return (
    <div
      className={cx('slot-toolbar', className, {
        'reveal-on-hover': revealOnHover,
        'slot-toolbar__outside': isDateTimeBlueprint && isDesktop,
      })}
    >
      {!isOnlySignupOption && (
        <>
          <Tooltip
            overlayClassName="slot-toolbar__tooltip"
            placement="left"
            overlay={
              <Typography
                as="span"
                variant="paragraph3"
                data-qa-id={`delete-tooltip-${index}`}
                color="charcoal"
              >
                Delete
              </Typography>
            }
            trigger={['hover']}
          >
            <Button
              variant="unstyled-button"
              className="slot-toolbar__button"
              data-qa-id={`delete-button-${index}`}
              onClick={() => onDeleteItem(index)}
              aria-label="Delete"
            >
              <CloseLineIcon ratio={0.75} color={pebble} />
            </Button>
          </Tooltip>
          {isDateTimeBlueprint && isDesktop && <Divider />}
        </>
      )}
      <Tooltip
        overlayClassName="slot-toolbar__tooltip"
        placement="left"
        overlay={
          <Typography
            as="span"
            variant="paragraph3"
            data-qa-id={`duplicate-tooltip-${index}`}
            color="charcoal"
          >
            Duplicate
          </Typography>
        }
        trigger={['hover']}
      >
        {isDateTimeBlueprint ? (
          <div>
            <DuplicateDropdown
              index={index}
              onDuplicateItem={onDuplicateItem}
              onCopySlotsToEmptyDate={onCopySlotsToEmptyDate}
              isOnlySignupOption={isOnlySignupOption}
            />
          </div>
        ) : (
          <Button
            variant="unstyled-button"
            className="slot-toolbar__button"
            data-qa-id={`duplicate-button-${index}`}
            onClick={() => onDuplicateItem(index)}
            aria-label="Duplicate"
          >
            <DuplicateIcon color={pebble} />
          </Button>
        )}
      </Tooltip>
      {isDateTimeBlueprint && isDesktop && !isAutoSorting && (canMoveUp || canMoveDown) && (
        <Divider />
      )}
      {canMoveUp && !isAutoSorting && (
        <>
          <Tooltip
            overlayClassName="slot-toolbar__tooltip"
            placement="left"
            overlay={
              <Typography
                as="span"
                variant="paragraph3"
                data-qa-id={`move-up-tooltip-${index}`}
                color="charcoal"
              >
                Move Up
              </Typography>
            }
            trigger={['hover']}
          >
            <Button
              variant="unstyled-button"
              className="slot-toolbar__button"
              data-qa-id={`move-up-button-${index}`}
              onClick={() => onMoveItemUp(index)}
              aria-label="Move up"
            >
              <ArrowIcon direction="up" ratio={0.625} color={pebble} />
            </Button>
          </Tooltip>
          {isDateTimeBlueprint && isDesktop && canMoveDown && <Divider />}
        </>
      )}
      {canMoveDown && !isAutoSorting && (
        <Tooltip
          overlayClassName="slot-toolbar__tooltip"
          placement="left"
          overlay={
            <Typography
              as="span"
              variant="paragraph3"
              data-qa-id={`move-down-tooltip-${index}`}
              color="charcoal"
            >
              Move Down
            </Typography>
          }
          trigger={['hover']}
        >
          <Button
            variant="unstyled-button"
            className="slot-toolbar__button"
            data-qa-id={`move-down-button-${index}`}
            onClick={() => onMoveItemDown(index)}
            aria-label="Move down"
          >
            <ArrowIcon direction="down" ratio={0.625} color={pebble} />
          </Button>
        </Tooltip>
      )}
    </div>
  );
};
